import { defineComponent } from "@vue/composition-api";
import usePromotedUsers from "@/views/PagePromotedUsers/hooks/usePromotedUsers";

export default defineComponent({
  name: "usersOnlineController",
  setup() {
    const { render, getFirstPage } = usePromotedUsers({
      isOnline: true,
    });
    getFirstPage();
    return render;
  },
});
